import { Component, OnInit } from "@angular/core";
import * as Highcharts from "highcharts";
import { first } from "rxjs/operators";
import { NewDashboardCorporateService } from "src/app/new-dashboard/core/service/new-dashboard-corporate.service";
import { DashboardDossierModel } from "../../core/model/DashboardDossierModel";
import { DashboardDossierProduit } from "../../core/model/DashboardDossierProduit";
import { DashboardDossierStatut } from "../../core/model/DashboardDossierStatut";
import { DashboardAllDirectionService } from '../../core/service/dashboard-all-direction.service';
import { ChartViewDTO } from '../../core/model/chart_view/chart-view-dto';
import { QuantiteDossierPortefeuilleParProduitDTO } from '../../core/model/quantite-dossier-portefeuille-par-produit-dto';

@Component({
  selector: "app-production",
  templateUrl: "./production.component.html",
  styleUrls: ["./production.component.scss"],
})
export class ProductionComponent implements OnInit {
  dossiersProduits: DashboardDossierProduit[];
  dossiersByProfils: DashboardDossierStatut[];
  dataSource: DashboardDossierModel[];
  cumulParStatut: any[];
  highcharts = Highcharts;
  updateFlag = false;
  chartOptions: any;
  chartOptionsMnt: any;
  totalCumulNombres: number = 0;
  totalCumulMontants: number = 0;
  codeDirection : String = 'DIRECTION_RISQUE';
  
  quantiteByPeriode: ChartViewDTO;
  montantByPeriode: ChartViewDTO;

  chartOptionsQuantiteByPeriode: any;
  chartOptionsMontantByPeriode: any;

  quantiteDossierPortefeuilleParProduitDTOs: QuantiteDossierPortefeuilleParProduitDTO[];

  constructor(private corporateService: NewDashboardCorporateService,
    private _dashboardAllDirectionService: DashboardAllDirectionService) {}

  ngOnInit() {
    //this.getDashboardCreditProduction();
    //this.getDossiersCreditByProfil();
    //this.getDossiersCreditByStatutAndProduit();

    this.quantiteDossierStatutSurLes6DerniersMois(this.codeDirection);
    this.montantDossierStatutSurLes6DerniersMois(this.codeDirection);
    this.quantiteDossierPortefeuilleParProduit(this.codeDirection);
  }
  getDossiersCreditByProfil() {
    this.corporateService.getDossiersCreditByProfil().subscribe((data) => {
      this.dossiersByProfils = data;
    });
  }

  getDossiersCreditByStatutAndProduit() {
    this.corporateService
      .getDossiersCreditByStatutAndProduit()
      .subscribe((data: DashboardDossierProduit[]) => {
        console.log(data);
        this.dossiersProduits = data;
      });
  }

  getDashboardCreditProduction() {
    this.corporateService.getDashboardCreditProduction().subscribe(
      (data) => {
        this.dataSource = data;
        const categories = [...new Set(data.map((item) => item.dateMonthYear))];
        const series = this.getSeriesByStatut(data);
        this.updateFlag = true;
        this.chartOptions = {
          chart: {
            type: "column",
          },
          title: {
            text: "Volume de dossiers par statut des 12 derniers mois",
          },
          xAxis: {
            categories: categories,
          },
          yAxis: {
            title: {
              text: "Volume",
            },
          },
          series: series[0],
        };

        this.chartOptionsMnt = {
          chart: {
            type: "column",
          },
          title: {
            text: "Montants par statut des 12 derniers mois",
          },
          xAxis: {
            categories: categories,
          },
          yAxis: {
            title: {
              text: "Montant(XOF)",
            },
          },
          tooltip: {
            valueSuffix: " XOF",
          },
          series: series[1],
        };
        this.updateFlag = true;
        this.cumulParStatut = this.getCumulParStatut(data);
        this.totalCumulNombres = this.getTotalCumulNombres(this.cumulParStatut);
        this.totalCumulMontants = this.getTotalCumulMontants(
          this.cumulParStatut
        );
      },
      (error) => {
        console.log("error", error);
      }
    );
  }

  getSeriesByStatut(data: any[]): any[] {
    const statuts = [...new Set(data.map((item) => item.statutDossier))];
    const nombreSeries = [];
    const montantSeries = [];

    statuts.forEach((statut) => {
      const serieNombreData = data
        .filter((item) => item.statutDossier === statut)
        .map((item) => item.nombreDossier);
      nombreSeries.push({ name: statut, data: serieNombreData });

      const serieMontantData = data
        .filter((item) => item.statutDossier === statut)
        .map((item) => item.montantDossier);
      montantSeries.push({ name: statut, data: serieMontantData });
    });

    return [nombreSeries, montantSeries];
  }

  getCumulParStatut(data: any[]): any[] {
    const statuts = [...new Set(data.map((item) => item.statutDossier))];
    const cumulParStatut = [];

    statuts.forEach((statut) => {
      const statutData = data.filter((item) => item.statutDossier === statut);
      const cumulNombres = statutData.reduce(
        (acc, item) => acc + item.nombreDossier,
        0
      );
      const cumulMontants = statutData.reduce(
        (acc, item) => acc + item.montantDossier,
        0
      );

      cumulParStatut.push({
        statutDossier: statut,
        cumulNombres: cumulNombres,
        cumulMontants: cumulMontants,
      });
    });

    return cumulParStatut;
  }

  getTotalCumulNombres(cumulParStatut: any[]): number {
    return cumulParStatut.reduce((acc, item) => acc + item.cumulNombres, 0);
  }
  getTotalCumulMontants(cumulParStatut: any[]): number {
    return cumulParStatut.reduce((acc, item) => acc + item.cumulMontants, 0);
  }

  
  //
  
  quantiteDossierStatutSurLes6DerniersMois(codeDirection) {
    this._dashboardAllDirectionService
      .quantiteDossierStatutSurLes6DerniersMois(codeDirection)
      .pipe(first())
      .subscribe(
        (response) => {
          this.quantiteByPeriode = response;

          this.chartOptionsQuantiteByPeriode = {
            chart: {
              type: "column",
            },
            title: {
              text: "Quantité de dossier sur les 6 derniers mois",
            },
            subtitle: {
              text: null,
            },
            xAxis: {
              categories: this.quantiteByPeriode.categories,
            },
            yAxis: {
              title: {
                text: "Qté",
              },
            },
            tooltip: {
              valueSuffix: null,
            },

            legend: {
              layout: "vertical",
              align: "right",
              verticalAlign: "top",
              x: 0,
              y: 100,
              floating: false,
              borderWidth: 1,

              backgroundColor: "#FFFFFF",
              shadow: true,
            },

            series: this.quantiteByPeriode.series,
          };
        },
        (error) => {
          console.log(error);
        }
      );
  }

  montantDossierStatutSurLes6DerniersMois(codeDirection) {
    this._dashboardAllDirectionService
      .montantDossierStatutSurLes6DerniersMois(codeDirection)
      .pipe(first())
      .subscribe(
        (response) => {
          this.montantByPeriode = response;

          this.chartOptionsMontantByPeriode = {
            chart: {
              type: "column",
            },
            title: {
              text: "Montant de dossier sur les 6 derniers mois",
            },
            subtitle: {
              text: null,
            },
            xAxis: {
              categories: this.montantByPeriode.categories,
            },
            yAxis: {
              title: {
                text: "Qté",
              },
            },
            tooltip: {
              valueSuffix: null,
            },

            legend: {
              layout: "vertical",
              align: "right",
              verticalAlign: "top",
              x: 0,
              y: 100,
              floating: false,
              borderWidth: 1,

              backgroundColor: "#FFFFFF",
              shadow: true,
            },

            series: this.montantByPeriode.series,
          };
        },
        (error) => {
          console.log(error);
        }
      );
  }

  //

  
  quantiteDossierPortefeuilleParProduit(codeDirection) {
    this._dashboardAllDirectionService
      .quantiteDossierPortefeuilleParProduit(codeDirection)
      .pipe(first())
      .subscribe(
        (response) => {
          this.quantiteDossierPortefeuilleParProduitDTOs = response;
        },
        (error) => {
          console.log(error);
        }
      );
  }


}
